<div
  class="flex flex-col fixed items-start justify-start w-full h-fit bg-[#F7F9FF] flex-nowrap z-40"
>
  <!-- Desktop Layout (min-[1024px]) -->
  <div
    class="hidden m-auto min-[1024px]:flex flex-row items-center justify-between w-full h-fit pl-8 pr-[32.02px] pt-4 pb-4 max-w-[1536px] flex-nowrap"
  >
    <!-- Logo -->
    <div class="flex flex-row items-start justify-start w-[190px] h-fit flex-nowrap">
      <a href="https://www.fromscratch.io/" target="_blank" rel="noopener noreferrer">
        <img src="logo.png" alt="fromScratch home page (opens in a new tab)" class="w-full h-fit" />
      </a>
    </div>
    <!-- Nav Menu Items -->
    <div class="flex flex-row items-center justify-start w-fit h-fit gap-8 flex-nowrap">
      @for (item of navItems; track item.sectionId) {
        <app-menu-item
          [label]="item.label"
          [status]="getStatus(item.sectionId)"
          (click)="scrollToSection(item.sectionId)"
          class="w-fit h-fit"
        ></app-menu-item>
      }
    </div>
    <!-- Primary Button -->
    <app-primary-button
      class="w-fit h-fit"
      [size]="primaryButtonSize()"
      [label]="primaryButtonLabel()"
      (buttonClicked)="navigateToChallenge()"
    ></app-primary-button>
  </div>

  <!-- Mobile Layout (max-[1279px]) -->
  <div
    class="flex min-[1024px]:hidden flex-row items-center justify-between w-full h-fit pl-8 pr-[32.02px] pt-4 pb-4 max-w-[1536px] flex-nowrap"
  >
    <!-- Logo -->
    <div class="flex flex-col items-start justify-start w-[160px] h-fit flex-nowrap">
      <a href="https://www.fromscratch.io/" target="_blank" rel="noopener noreferrer">
        <img src="logo.png" alt="fromScratch home page (opens in a new tab)" class="w-full h-fit" />
      </a>
    </div>
    <!-- Primary Button (small on mobile) -->
    <app-primary-button
      class="w-fit h-fit"
      [size]="'small'"
      [label]="primaryButtonLabel()"
      (buttonClicked)="navigateToChallenge()"
    ></app-primary-button>
  </div>
</div>
